<template>
    <div class="home" id="index">
        <div class="header">
            <Header class="box " />
        </div>
        <div class="main-content">
            <router-view :key="$route.fullPath" />
        </div>
        <div class="footer-content">
            <Footer class="box" />
        </div>
    </div>
</template>
  
<script>
import Header from '@/views/portal/components/Header.vue';
import Footer from '@/views/portal/components/Footer.vue';
export default {
    name: 'pandatea-layout',
    components: {
        Header,
        Footer
    },
    computed: {

    },
    methods: {

    }
}
  </script>
  
  <style lang="less" scoped>
.home {
    min-height: 100%;
    display: flex;
    flex-direction: column;
}
.main-content {
    flex: 1;
}
.container {
    height: 100%;
    // border: 1px solid #eee;
}
.is-vertical {
    width: 0;
}
.header{
    position: sticky;
    box-shadow: var(--box_shadow1);
    top: 0;
    z-index: 99;
    padding: 10px 20px;
    background: #33402f;
}
</style>
  